import React, { useState } from 'react';
import { FaShoppingCart, FaTruck } from 'react-icons/fa';

import InventorySupplier from './InventorySupplier';
import InventoryPurchases from './InventoryPurchases';

import './css/Inventory.css';
import './css/Menu.css';
import './css/MenuNav.css';
import './css/Order.css';
import './css/Purchase.css';
import './css/Receivables.css';

/** Store purchase tab — suppliers & purchases via store inventory APIs. */
const StorePurchase = () => {
  const [purchaseSubView, setPurchaseSubView] = useState('purchases');
  const [purchasesPreselectedSupplierName, setPurchasesPreselectedSupplierName] = useState('');

  return (
    <div className="menu inventory-page purchase-page finance-page">
      <div className="menu-nav finance-nav">
        <div
          className="menu-nav__tabs menu-nav__tabs--underline"
          role="tablist"
          aria-label="Purchase sections"
        >
          <button
            type="button"
            role="tab"
            aria-selected={purchaseSubView === 'supplier'}
            className={`menu-nav__tab ${purchaseSubView === 'supplier' ? 'is-active' : ''}`}
            onClick={() => setPurchaseSubView('supplier')}
          >
            <FaTruck className="menu-nav__tab-icon" aria-hidden="true" />
            <span>Suppliers</span>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={purchaseSubView === 'purchases'}
            className={`menu-nav__tab ${purchaseSubView === 'purchases' ? 'is-active' : ''}`}
            onClick={() => setPurchaseSubView('purchases')}
          >
            <FaShoppingCart className="menu-nav__tab-icon" aria-hidden="true" />
            <span>Purchases</span>
          </button>
        </div>
      </div>

      <div className="purchase-tab-panel finance-tab-panel">
        <div className="finance-content-panel">
          {purchaseSubView === 'supplier' && (
            <InventorySupplier
              onSupplierCreated={(supplier) => {
                const name = String(
                  supplier?.supplierName ?? supplier?.Supplier_Name ?? ''
                ).trim();
                if (name) setPurchasesPreselectedSupplierName(name);
                setPurchaseSubView('purchases');
              }}
            />
          )}

          {purchaseSubView === 'purchases' && (
            <InventoryPurchases
              preselectedSupplierName={purchasesPreselectedSupplierName}
              onPreselectedSupplierConsumed={() => setPurchasesPreselectedSupplierName('')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StorePurchase;
